import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsIncidentReportService} from '../../../services/settings-incident-report.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'notification-modal',
    templateUrl: './notification-modal.component.html',
    styleUrls: ['./notification-modal.component.scss']
})
export class NotificationModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    showEditPanel = false;
    agreementText = '';
    subject = '';
    originalMessage = '';
    originalSubject = '';
    emailTemplate = null;
    placeholders = [
        '[[INCIDENT_REPORT_ID]]',
        '[[INCIDENT_TYPE]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[UNIT_NUMBER]]',
        '[[RESIDENT_NAME]]',
        '[[CREATED_ON]]',
        '[[REPORT_AREA]]',
        '[[REPORTED_BY]]',
        '[[INCIDENT_TEXT]]',
        '[[LINK_TO_PDF]]',
        '[[STAFF_MEMBER_NAME]]',
        '[[MODIFIED_BY]]',
        '[[MODIFIED_ON]]',
        '[[DELETED_BY]]',
        '[[DELETED_ON]]',
        '[[INCIDENT_AT]]'
    ];
    emailTemplates = [];
    showSpinner = false;

    constructor(
        public api: ApiClientService,
        public settingsIncidentReportService: SettingsIncidentReportService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.getEmailTemplates(this.settingsIncidentReportService.notificationModalStaffOrResident);
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsIncidentReportService.selectedItemData[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings']) {
            this.settingsIncidentReportService.selectedItemData[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].forEach((setting) => {
                if(setting.action == this.settingsIncidentReportService.notificationModalNotificationType) {
                    if(!setting.subject && !setting.message) {
                        this.emailTemplate = setting.template ? setting.template.id : null;
                        this.emailTemplates.forEach((template) => {
                            if (template.id == this.emailTemplate) {
                                this.subject = template.subject;
                                this.agreementText = template.message;
                                this.originalMessage = template.message;
                                this.originalSubject = template.subject;
                            }
                        });
                    } else {
                        this.emailTemplate = 0;
                        this.subject = setting.subject;
                        this.agreementText = setting.message;
                        this.originalMessage = setting.message;
                        this.originalSubject = setting.subject;
                    }
                }
            });
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsIncidentReportService.isNotificationModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsIncidentReportService.isNotificationModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.emailTemplate && form.value.emailTemplate !== 0) toastr.warning('Email template should not be blank.');
            if (!form.value.subject) toastr.warning('Email subject should not be blank.');
            return;
        }
        if(!this.agreementText) {
            toastr.warning('Email text should not be blank.');
            return;
        }
        const emailTemplate = form.value.emailTemplate;
        const formattedAction = this.settingsIncidentReportService.notificationModalNotificationType;

        if (!emailTemplate && emailTemplate !== 0) { toastr.warning('Email template is not set.'); return; }
        let index = -1;
        let data = {[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings']: []};
        if(this.settingsIncidentReportService.selectedItemData[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings']) {
            this.settingsIncidentReportService.selectedItemData[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].filter((setting) => {
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].push({
                    action: setting.action,
                    template: setting.template ? setting.template.id : null
                });
            });
        }
        index = data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].findIndex(notification => notification.action == formattedAction);

        if(index != -1) {
            data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index] = {
                action: formattedAction
            };
            if(this.emailTemplate === 0 || this.templateMessageIsModified()) {
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index].template = null;
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index].subject = this.subject;
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index].message = this.agreementText;
            } else {
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index].template = this.emailTemplate;
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index].subject = '';
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'][index].message = '';
            }
        } else {
            data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].push({
                action: formattedAction,
            });
            if(this.emailTemplate === 0) {
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].filter((notification) => {
                    if(notification.action == formattedAction) {
                        notification.subject = this.subject;
                        notification.message = this.agreementText;
                    }
                });
            } else {
                data[this.settingsIncidentReportService.notificationModalStaffOrResident + 'NotificationSettings'].filter((notification) => {
                    if(notification.action == formattedAction) {
                        notification.template = this.emailTemplate;
                    }
                });
            }
        }

        this.disabledSubmit = true;
        const url = `/v1/settings/${this.settingsIncidentReportService.selectedItemData.id}.json`;
        this.api.patch('domainIncidentReports', url, data).subscribe(
            () => this.updateView('Email template has been updated successfully', data),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Email template has failed to update');
            }
        );
    }

    updateView(msg: string, data): void {
        toastr.success(msg);
        // this.updateInfo(data);
        this.settingsIncidentReportService.getData();
        this.form.reset();
        this.hideModal();
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    initSummernote(enabled) {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: {
                onChange: contents => {
                    this.agreementText = contents;
                    this.emailTemplate = 0;
                }
            },
            toolbar: enabled ? [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ] : [],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle"
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
                this.emailTemplate = 0;
            });
        $('.note-editable').html(this.agreementText).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });

        if(!enabled)
            summernote.summernote('disable');
    }

    showEditPanelSetter(): void {
        this.showEditPanel = true;
        setTimeout( () => this.initSummernote(true), 300);
    }

    emailTemplateSelect(arr: Array<any>) {
        return arr.map(template => ({value: template.id, optionText: template.name}));
    }
    changeTemplate(event): void {
        this.emailTemplate = event;
        if(event == -1) {
            this.agreementText = '';
            document.getElementsByClassName('note-editable panel-body')[0].innerHTML = '';
        } else {
            const templateObject = this.emailTemplates.find( (template) => template.id == event);
            if(templateObject) {
                if(templateObject.id != 0) {
                    this.subject = templateObject.subject;
                    this.agreementText = templateObject.message;
                    document.getElementsByClassName('note-editable panel-body')[0].innerHTML = templateObject.message;
                } else {
                    this.subject = '';
                    this.agreementText = '';
                    document.getElementsByClassName('note-editable panel-body')[0].innerHTML = '';
                }
            }
        }
    }

    public getEmailTemplates(type) {
        this.showSpinner = true;
        const url = `/v1/notification_templates.json?per-page=1000`;
        this.api.get('domainIncidentReports', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.emailTemplates = body.entities;
                this.emailTemplates.push({id: 0, name: 'Other'});
                this.initData();
                this.showSpinner = false;
                this.initSummernote(false);
            },
            error => this.api.errorHandler(error, 'Failed get Templates')
        );
    }

    templateMessageIsModified(): boolean {
        let isModified = false;
        let originalTemplateMessage = '';
        this.emailTemplates.forEach( template => {
           if(template.id == this.emailTemplate)
               originalTemplateMessage = template.message.replace(/&nbsp;/g, '').replace(/\s/g, '').replace(/<br>/g, '');
        });
        const messageToSend = this.agreementText.replace(/&nbsp;/g, '').replace(/\s/g, '').replace(/<br>/g, '');
        if(originalTemplateMessage != messageToSend)
            isModified = true;
        return isModified;
    }

    hideEditPanelSetter() {
        this.showEditPanel = false;
        setTimeout( () => this.initSummernote(false), 300);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/notification-modal/notification-modal.component.ts